var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 0.333984H25.6663V4.21386C24.0277 4.21386 22.6994 5.54222 22.6994 7.18083C22.6994 8.81944 24.0277 10.1478 25.6663 10.1478V14.0277H0.333008V10.1478C1.97161 10.1478 3.29997 8.81944 3.29997 7.18083C3.29997 5.54222 1.97161 4.21386 0.333008 4.21386V0.333984Z",
    fill: "#A1A3A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 7.63116V5.19824H14.522V7.63116H20.875Z",
    fill: "#C6C6C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0674 5.19854V2.76562H9.63447V5.19854H12.0674Z",
    fill: "#C6C6C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 2.7669V0.333984L14.522 0.333984V2.7669L20.875 2.7669Z",
    fill: "#C6C6C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4769 7.6748H12.0439V14.0278H14.4769V7.6748Z",
    fill: "#C6C6C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6126 7.6748H7.17969V14.0278H9.6126V7.6748Z",
    fill: "#C6C6C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon);
export default __webpack_public_path__ + "static/media/voucher-icon.5b6ddf3ea612178dd3e0e8027dd14cdf.svg";
export { ForwardRef as ReactComponent };